<template>
  <div class="article-frame sup-page-frame">
    <div class="article-box sup-page-box">
      <img class="header-img" :src="$getThemeImagePath('sup/sup_vip_class_upgrading_banner.jpg')" alt="ショップについて">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="sup-page-title">
          ショップについて
        </h1>
        <p class="sup-page-lead">
          VIP昇格ボーナスなどの各種ボーナスは、「ショップ」でご自身で手軽に受け取ることができます。<br>また、不定期開催の特典で発行される「クーポンコード」も「ショップ」で簡単に交換できます。
        </p>
        <div class="sup-wallet-index">
          <p class="sup-wallet-index-title">
            ショップの利用方法
          </p>
          <div class="sup-wallet-index-list">
            <a class="sup-wallet-index-btn" href="#vip-bonus">
              <span>VIPボーナス・特典の受け取り方法</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
            <a class="sup-wallet-index-btn" href="#coupon">
              <span>クーポンコードの利用方法</span>
              <span class="sup-wallet-index-arrow"><svg width="12" height="7" viewBox="0 0 12 7"><path d="M1 1L6 6L11 1" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /></svg></span>
            </a>
          </div>
        </div>
        <div id="vip-bonus" class="sup-steps-box">
          <p class="sup-steps-box-title">
            VIPボーナス・特典の受け取り方法
          </p>
          <div class="sup-step">
            <div class="sup-wallet-content-list">
              <p>➊ ホーム画面の「詳細」＞「ショップ」をタップ</p>
              <p>➋ 「報酬受け取り」をタップ</p>
              <p>➌ 受け取りたいボーナスを選択</p>
              <p>➍ 受取ボタンを押してボーナス獲得</p>
            </div>
            <p class="sup-step-caution">
              ※獲得条件を達成すると、該当項目の鍵が解除されます。<br>鍵マークが表示されている場合は、条件未達成のため受け取ることはできません。
            </p>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_vip_class_upgrading1.jpg')" alt="ショップ画面1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_vip_class_upgrading2.jpg')" alt="ショップ画面2">
            </div>
          </div>
        </div>
        <div id="coupon" class="sup-steps-box sup-steps-box--mt">
          <p class="sup-steps-box-title">
            クーポンコードの利用方法
          </p>
          <div class="sup-step">
            <div class="sup-wallet-content-list">
              <p>➊ ホーム画面の「詳細」＞「ショップ」をタップ</p>
              <p>➋ 「クーポン」をタップ</p>
              <p>➌ 「クーポンコード」を入力</p>
              <p>➍ 「交換」をタップ</p>
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_vip_class_upgrading2.jpg')" alt="クーポン画面1">
            </div>
            <div class="sup-step-img-wrap">
              <img class="sup-step-img" :src="$getThemeImagePath('sup/sup_vip_class_upgrading3.jpg')" alt="クーポン画面2">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {

    }
  },
  computed: {
  },
  created() {
  },
  methods: {

  }
}
</script>
